/** Copyright (c) 2022 T. Rowe Price. All rights reserved. */

import './BeneficiariesFooter.scss';

import PropTypes from 'prop-types';
import React from 'react';

import Content, { contentConverter } from 'services/Content';

const BeneficiariesFooter = ({
  brokerageAdvantage,
  hasIndividualOrJointTenant,
  hasROTHOrTraditionalInheritedIRABene,
  hasWorkplaceRetirementAccounts,
  isAlaska529,
  isMaryland529,
  isNational529,
  hasMultipleCollegeSavings
}) => {
  const brandingMessage = () => {
    switch (true) {
      case isAlaska529 && !isMaryland529 && !isNational529:
        return Content.beneficiaryImportantInfo.ak529;
      case !isAlaska529 && isMaryland529 && !isNational529:
        return Content.beneficiaryImportantInfo.md529;
      case !isAlaska529 && !isMaryland529 && isNational529:
        return Content.beneficiaryImportantInfo.national529;
      case hasMultipleCollegeSavings:
        return Content.beneficiaryImportantInfo.multi529;
      default:
        return '';
    }
  };
  const renderImportantInfoSection = () => {
    const showImportantInfoSection =
      brokerageAdvantage ||
      hasIndividualOrJointTenant ||
      hasROTHOrTraditionalInheritedIRABene ||
      hasWorkplaceRetirementAccounts ||
      isAlaska529 ||
      isMaryland529 ||
      isNational529 ||
      hasMultipleCollegeSavings;
    if (!showImportantInfoSection) {
      return <></>;
    }
    return (
      <div className="important-information">
        <div className="title">Important Information</div>
        {hasIndividualOrJointTenant && (
          <div
            className="message"
            dangerouslySetInnerHTML={{
              __html: contentConverter.makeHtml(
                Content.beneficiaryImportantInfo.individualOrJoint
              )
            }}
          />
        )}
        {(brokerageAdvantage || hasROTHOrTraditionalInheritedIRABene) && (
          <div
            className="message"
            dangerouslySetInnerHTML={{
              __html: contentConverter.makeHtml(
                Content.beneficiaryImportantInfo.brokerageOrROTHTrad
              )
            }}
          />
        )}
        {brandingMessage() && (
          <div
            className="message"
            data-testid="brandingMessage"
            dangerouslySetInnerHTML={{
              __html: contentConverter.makeHtml(brandingMessage())
            }}
          />
        )}
        {hasWorkplaceRetirementAccounts && (
          <div
            className="message"
            dangerouslySetInnerHTML={{
              __html: contentConverter.makeHtml(
                Content.beneficiaryImportantInfo.tracOrWorkplaceRPS
              )
            }}
          />
        )}
      </div>
    );
  };

  return (
    <div className="beneficiaries-footer-copy">
      {renderImportantInfoSection()}
    </div>
  );
};

BeneficiariesFooter.propTypes = {
  brokerageAdvantage: PropTypes.bool.isRequired,
  hasIndividualOrJointTenant: PropTypes.bool.isRequired,
  hasROTHOrTraditionalInheritedIRABene: PropTypes.bool.isRequired,
  hasWorkplaceRetirementAccounts: PropTypes.bool.isRequired,
  isAlaska529: PropTypes.bool.isRequired,
  isMaryland529: PropTypes.bool.isRequired,
  isNational529: PropTypes.bool.isRequired,
  hasMultipleCollegeSavings: PropTypes.bool.isRequired
};

export default BeneficiariesFooter;
